<template>
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="类型">
        <el-select v-model="queryParams.type" class="!w-120px" clearable placeholder="全部">
          <el-option label="红包" :value="1" />
          <el-option label="大转盘" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" class="!w-120px" clearable placeholder="全部">
          <el-option label="未开始" :value="0" />
          <el-option label="进行中" :value="1" />
          <el-option label="已结束" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button type="primary" @click="openCreate(1)">
          <Icon class="mr-5px" icon="ep:plus" />创建红包
        </el-button>
        <el-button type="primary" plain @click="openCreate(2)">
          <Icon class="mr-5px" icon="ep:plus" />创建大转盘
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="ID" prop="id" width="80" />
      <el-table-column label="类型" width="100">
        <template #default="{ row }">{{ row.type === 2 ? '大转盘' : '红包' }}</template>
      </el-table-column>
      <el-table-column label="标题" prop="title" min-width="140" show-overflow-tooltip />
      <el-table-column label="直播间" min-width="160" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.liveTitle || '—' }}
          <span class="text-gray-400">（{{ row.liveId }}）</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="{ row }">
          <el-tag :type="statusTag(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" width="250" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row)">查看</el-button>
          <el-button link type="primary" @click="openRewards(row.id)">领取记录</el-button>
          <el-button v-if="row.status === 1" link type="danger" @click="handleStop(row.id)"
            >结束</el-button
          >
          <el-button v-if="row.status === 0" link type="success" @click="handleStart(row.id)">
            发起
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="queryParams.pageNo"
      v-model:limit="queryParams.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <el-dialog
    v-model="formVisible"
    :title="form.type === 2 ? '创建大转盘' : '创建红包'"
    width="640px"
    @closed="resetForm"
  >
    <el-form ref="formRef" :model="form" :rules="formRules" label-width="110px">
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="form.title" maxlength="80" show-word-limit clearable />
      </el-form-item>
      <el-form-item label="直播间" prop="liveId">
        <el-select
          v-model="form.liveId"
          class="!w-full"
          filterable
          clearable
          default-first-option
          :filter-method="filterRoomOptions"
          :no-data-text="roomFilterEmptyText"
          placeholder="输入编号或标题搜索，点选下方列表"
        >
          <el-option
            v-for="room in filteredRoomOptions"
            :key="room.id"
            :label="`${room.title || '未命名'}（#${room.id}）`"
            :value="room.id!"
          >
            <div class="live-id-option">
              <span class="live-id-option__name">{{ room.title || '未命名' }}</span>
              <span class="live-id-option__id">编号 {{ room.id }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <template v-if="form.type === 1">
        <el-form-item label="金额模式">
          <el-radio-group v-model="redPacket.random">
            <el-radio :value="false" border>固定金额</el-radio>
            <el-radio :value="true" border>随机金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="redPacket.random ? '总金额(元)' : '单个金额(元)'" prop="amount">
          <el-input-number
            v-model="redPacket.amount"
            class="!w-full"
            :min="0.01"
            :precision="2"
            :controls="false"
          />
        </el-form-item>
        <el-form-item label="红包个数">
          <el-input-number
            v-model="redPacket.remainingCount"
            class="!w-full"
            :min="1"
            :precision="0"
            :controls="false"
          />
        </el-form-item>
      </template>

      <template v-else>
        <el-form-item label="奖品">
          <el-alert
            title="权重决定中奖概率；份数为本活动可发放数量。商品请填写本店商品ID。"
            type="info"
            :closable="false"
            class="mb-12px"
          />
          <div class="w-full">
            <div
              v-for="(prize, index) in wheelPrizes"
              :key="index"
              class="mb-12px flex flex-wrap gap-8px items-center border border-gray-200 rounded-6px p-10px"
            >
              <el-input v-model="prize.name" class="!w-120px" placeholder="名称" />
              <el-select v-model="prize.type" class="!w-110px">
                <el-option label="余额" value="balance" />
                <el-option label="商品" value="goods" />
                <el-option label="谢谢参与" value="miss" />
              </el-select>
              <el-input-number
                v-if="prize.type === 'balance'"
                v-model="prize.amount"
                class="!w-110px"
                :min="0"
                :precision="2"
                :controls="false"
                placeholder="金额"
              />
              <el-input
                v-if="prize.type === 'goods'"
                v-model="prize.goodsId"
                class="!w-110px"
                placeholder="商品ID"
              />
              <el-input-number
                v-model="prize.weight"
                class="!w-90px"
                :min="0"
                :precision="0"
                :controls="false"
                placeholder="权重"
              />
              <el-input-number
                v-model="prize.stock"
                class="!w-90px"
                :min="0"
                :precision="0"
                :controls="false"
                placeholder="奖品份数"
              />
              <el-button link type="danger" @click="wheelPrizes.splice(index, 1)">删除</el-button>
            </div>
            <el-button @click="addPrize">添加奖品</el-button>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <template #footer>
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitCreate">创建</el-button>
    </template>
  </el-dialog>

  <el-drawer v-model="detailVisible" title="活动详情" size="460px">
    <el-descriptions v-if="detail" :column="1" border>
      <el-descriptions-item label="标题">{{ detail.title }}</el-descriptions-item>
      <el-descriptions-item label="类型">{{
        detail.type === 2 ? '大转盘' : '红包'
      }}</el-descriptions-item>
      <el-descriptions-item label="直播间">
        {{ detail.liveTitle || '—' }}（{{ detail.liveId }}）
      </el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabel(detail.status) }}</el-descriptions-item>
      <el-descriptions-item label="配置">
        <pre class="text-12px whitespace-pre-wrap m-0">{{ prettyConfig(detail.configJson) }}</pre>
      </el-descriptions-item>
    </el-descriptions>
  </el-drawer>
  <el-dialog v-model="rewardsVisible" title="活动领取记录" width="1000px">
    <el-table :data="rewards" v-loading="rewardsLoading">
      <el-table-column label="记录编号" prop="id" width="90" />
      <el-table-column label="用户编号" prop="userId" width="90" />
      <el-table-column label="奖励" min-width="140">
        <template #default="{ row }">{{
          row.prizeName || (row.rewardType === 'balance' ? `${row.amount} 元余额` : '谢谢参与')
        }}</template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template #default="{ row }">{{ rewardStatus(row) }}</template>
      </el-table-column>
      <el-table-column label="收货信息" min-width="240">
        <template #default="{ row }">
          <template v-if="row.receiver"
            >{{ row.receiver.name }} / {{ row.receiver.mobile }} / {{ row.receiver.areaName }}
            {{ row.receiver.detailAddress }}</template
          >
          <template v-else>—</template>
        </template>
      </el-table-column>
      <el-table-column label="物流" min-width="150">
        <template #default="{ row }">{{ row.logisticsName }} {{ row.logisticsNo }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template #default="{ row }"
          ><el-button
            v-if="row.deliveryStatus === 'awaiting_delivery'"
            link
            type="primary"
            @click="openDelivery(row.id)"
            >发货</el-button
          ></template
        >
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="rewardQuery.pageNo"
      v-model:limit="rewardQuery.pageSize"
      :total="rewardTotal"
      @pagination="loadRewards"
    />
  </el-dialog>
  <el-dialog v-model="deliveryVisible" title="奖品发货" width="450px">
    <el-form label-width="90px">
      <el-form-item label="物流公司"
        ><el-input v-model="deliveryForm.logisticsName" maxlength="60"
      /></el-form-item>
      <el-form-item label="物流单号"
        ><el-input v-model="deliveryForm.logisticsNo" maxlength="64"
      /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="deliveryVisible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submitDelivery"
        >确认发货</el-button
      ></template
    >
  </el-dialog>
</template>

<script setup lang="ts">
import type { FormInstance, FormRules } from 'element-plus'
import * as LiveApi from '@/api/merchant/live'
import { dateFormatter } from '@/utils/formatTime'

defineOptions({ name: 'MerchantLiveActivity' })

interface WheelPrize {
  name: string
  type: 'balance' | 'goods' | 'miss'
  weight: number
  stock: number
  amount?: number
  goodsId?: string
}

const message = useMessage()
const loading = ref(false)
const submitting = ref(false)
const list = ref<LiveApi.LiveActivityVO[]>([])
const total = ref(0)
const roomOptions = ref<LiveApi.LiveRoomSimpleVO[]>([])
const filteredRoomOptions = ref<LiveApi.LiveRoomSimpleVO[]>([])
const roomFilterEmptyText = ref('暂无关联主播的直播间')
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  type: undefined as number | undefined,
  status: undefined as number | undefined
})

const filterRoomOptions = (query: string) => {
  const text = String(query || '').trim().toLowerCase()
  if (!text) {
    filteredRoomOptions.value = [...roomOptions.value]
    roomFilterEmptyText.value = roomOptions.value.length
      ? '暂无数据'
      : '暂无关联主播的直播间'
    return
  }
  filteredRoomOptions.value = roomOptions.value.filter((room) => {
    const idMatch = String(room.id ?? '').includes(text)
    const titleMatch = String(room.title || '')
      .toLowerCase()
      .includes(text)
    return idMatch || titleMatch
  })
  roomFilterEmptyText.value = filteredRoomOptions.value.length
    ? '暂无数据'
    : `未找到「${query}」，可改用标题或编号搜索`
}

const formVisible = ref(false)
const formRef = ref<FormInstance>()
const form = reactive<{
  type: number
  title: string
  liveId?: number
}>({
  type: 1,
  title: '',
  liveId: undefined
})
const redPacket = reactive({
  random: false,
  amount: 1,
  remainingCount: 10
})
const wheelPrizes = ref<WheelPrize[]>([
  { name: '余额1元', type: 'balance', weight: 10, stock: 100, amount: 1 },
  { name: '谢谢参与', type: 'miss', weight: 5, stock: 9999 }
])

const formRules: FormRules = {
  title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
  liveId: [{ required: true, message: '请选择直播间', trigger: 'change' }]
}

const detailVisible = ref(false)
const detail = ref<LiveApi.LiveActivityVO | null>(null)

const statusLabel = (status?: number) => {
  if (status === 0) return '未开始'
  if (status === 1) return '进行中'
  if (status === 2) return '已结束'
  return status != null ? String(status) : '—'
}
const statusTag = (status?: number) => {
  if (status === 0) return 'info'
  if (status === 1) return 'success'
  if (status === 2) return 'warning'
  return 'info'
}

const prettyConfig = (json?: string) => {
  if (!json) return '—'
  try {
    return JSON.stringify(JSON.parse(json), null, 2)
  } catch {
    return json
  }
}

const getList = async () => {
  loading.value = true
  try {
    const data = await LiveApi.getLiveActivityPage({
      pageNo: queryParams.pageNo,
      pageSize: queryParams.pageSize,
      type: queryParams.type,
      status: queryParams.status
    })
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const loadRooms = async () => {
  const data = await LiveApi.getLiveRoomSimpleList()
  roomOptions.value = Array.isArray(data) ? data : []
  filteredRoomOptions.value = [...roomOptions.value]
  roomFilterEmptyText.value = roomOptions.value.length
    ? '暂无数据'
    : '暂无关联主播的直播间'
}

const openCreate = async (type: number) => {
  form.type = type
  await loadRooms()
  if (!roomOptions.value.length) {
    message.warning('暂无关联主播的直播间，请先关联主播并开播')
  }
  formVisible.value = true
}

const addPrize = () => {
  wheelPrizes.value.push({ name: '', type: 'balance', weight: 1, stock: 10, amount: 1 })
}

const resetForm = () => {
  form.title = ''
  form.liveId = undefined
  redPacket.random = false
  redPacket.amount = 1
  redPacket.remainingCount = 10
  wheelPrizes.value = [
    { name: '余额1元', type: 'balance', weight: 10, stock: 100, amount: 1 },
    { name: '谢谢参与', type: 'miss', weight: 5, stock: 9999 }
  ]
  formRef.value?.clearValidate()
}

const buildConfigJson = (): string => {
  if (form.type === 1) {
    return JSON.stringify({
      random: redPacket.random,
      amount: redPacket.amount,
      remainingCount: redPacket.remainingCount
    })
  }
  const prizes = wheelPrizes.value.map((p) => {
    const item: Record<string, unknown> = {
      name: p.name,
      type: p.type,
      weight: p.weight,
      stock: p.stock
    }
    if (p.type === 'balance') item.amount = p.amount
    if (p.type === 'goods') item.goodsId = p.goodsId
    return item
  })
  return JSON.stringify({ prizes })
}

const submitCreate = async () => {
  await formRef.value?.validate()
  if (form.type === 2) {
    if (!wheelPrizes.value.length) {
      message.warning('请至少添加一个奖品')
      return
    }
    if (wheelPrizes.value.some((p) => !p.name?.trim())) {
      message.warning('奖品名称不能为空')
      return
    }
  }
  submitting.value = true
  try {
    await LiveApi.createLiveActivity({
      type: form.type,
      title: form.title,
      liveId: form.liveId,
      configJson: buildConfigJson()
    })
    message.success('创建成功')
    formVisible.value = false
    await getList()
  } finally {
    submitting.value = false
  }
}

const openDetail = (row: LiveApi.LiveActivityVO) => {
  detail.value = row
  detailVisible.value = true
}

const handleStart = async (id?: number) => {
  if (!id) return
  try {
    await message.confirm('确认发起该活动？发起后观众可领取。')
  } catch {
    return
  }
  await LiveApi.startLiveActivity(id)
  message.success('已发起')
  await getList()
}

const rewardsVisible = ref(false)
const rewardsLoading = ref(false)
const rewards = ref<LiveApi.LiveRewardVO[]>([])
const rewardTotal = ref(0)
const rewardQuery = reactive({ activityId: 0, pageNo: 1, pageSize: 10 })
const deliveryVisible = ref(false)
const deliveryForm = reactive({ claimId: 0, logisticsName: '', logisticsNo: '' })
const rewardStatus = (row: LiveApi.LiveRewardVO) => {
  if (row.rewardType === 'balance') return '已入余额'
  if (row.rewardType === 'miss') return '未中奖'
  return (
    (
      {
        awaiting_address: '待填写地址',
        awaiting_delivery: '待发货',
        delivered: '已发货',
        received: '已收货'
      } as Record<string, string>
    )[row.deliveryStatus || ''] || '待处理'
  )
}
const loadRewards = async () => {
  rewardsLoading.value = true
  try {
    const data = await LiveApi.getLiveRewardPage(rewardQuery)
    rewards.value = data.list
    rewardTotal.value = data.total
  } finally {
    rewardsLoading.value = false
  }
}
const openRewards = async (activityId: number) => {
  rewardQuery.activityId = activityId
  rewardQuery.pageNo = 1
  rewardsVisible.value = true
  await loadRewards()
}
const openDelivery = (claimId: number) => {
  Object.assign(deliveryForm, { claimId, logisticsName: '', logisticsNo: '' })
  deliveryVisible.value = true
}
const submitDelivery = async () => {
  if (
    !deliveryForm.logisticsName.trim() ||
    !/^[A-Za-z0-9-]{4,64}$/.test(deliveryForm.logisticsNo.trim())
  ) {
    message.warning('请填写物流公司及有效物流单号')
    return
  }
  submitting.value = true
  try {
    await LiveApi.deliverLiveReward({
      ...deliveryForm,
      logisticsName: deliveryForm.logisticsName.trim(),
      logisticsNo: deliveryForm.logisticsNo.trim()
    })
    message.success('奖品已发货')
    deliveryVisible.value = false
    await loadRewards()
  } finally {
    submitting.value = false
  }
}
const handleStop = async (id: number) => {
  await message.confirm('确认结束活动？结束后观众不能继续领取。')
  await LiveApi.stopLiveActivity(id)
  await getList()
}

onMounted(getList)
</script>

<style scoped>
.live-id-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}
.live-id-option__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.live-id-option__id {
  flex-shrink: 0;
  color: var(--el-text-color-secondary);
  font-size: 12px;
}
</style>
